// extracted by mini-css-extract-plugin
module.exports = {"reportForm":"style__reportForm__HTBvU","shapeReport":"style__shapeReport__f+ADG"};